export default __webpack_public_path__ + "static/memento-letters-5c6276281812c1ceaa50ea1846895f05.jpg";